import React, { Dispatch, SetStateAction } from "react";
import { Table, TableHeaderProps, TableProps, TableDataRowProps } from "../../../Common/UI/Index";
import { useGetArtefactSummary } from "../../../../service/hooks";
import { ResultView } from "../ResultDetail/ResultDetail";
import { IArtefactSummary } from "./interfaces";

interface IReportTableProps {
  className?: string;
  cohortExecutionId: string;
  setSwitchView: Dispatch<SetStateAction<string>>;
}

const tableHeader: TableHeaderProps[] = [
  {
    title: "ID",
    propertyName: "id",
    sortable: false,
    width: "5%"
  },
  {
    title: "Name",
    propertyName: "name",
    sortable: false,
  },
  {
    title: "Parent Count",
    propertyName: "parentCount",
    sortable: false,
    width: "7%"
  },
  {
    title: "Included",
    propertyName: "included",
    sortable: false,
    width: "7%"
  },
  {
    title: "Excluded",
    propertyName: "excluded",
    sortable: false,
    width: "7%"
  },
  {
    title: "Percentage",
    propertyName: "percentage",
    sortable: false,
    width: "7%"
  }
];


const buildDataRow = (
  data: IArtefactSummary[],
  setSwitchView: Dispatch<SetStateAction<string>>
): TableDataRowProps[] => {
  const handleSelectReport = (id: string, name: string): void => {
    sessionStorage.setItem("selectedReportArtefactId", id);
    sessionStorage.setItem("selectedReportArtefactName", name);
    setSwitchView(ResultView.CodeListView);
  };

  return data.map((item, index) => ({
    row: [
      { value: String(index + 1), propertyName: "id" },
      {
        value: (
          <a
            role="button"
            tabIndex={0}
            onClick={(): void => handleSelectReport(item.id, item.name)}
            onKeyDown={(e): void => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleSelectReport(item.id, item.name);
              }
            }}
          >
            {item.name}
          </a>
        ),
        propertyName: "name"
      },
      { value: String(item.parentCount), propertyName: "parentCount" },
      { value: String(item.included), propertyName: "included" },
      { value: String(item.excluded), propertyName: "excluded" },
      { value: String(item.percentage), propertyName: "percentage" }
    ]
  }));
};

export const ReportTable: React.FC<IReportTableProps> = ({ className, cohortExecutionId, setSwitchView }) => {
  const { data: { data } } = useGetArtefactSummary(cohortExecutionId);

  const tableData: TableProps = {
    headerRow: tableHeader,
    dataRow: buildDataRow(data.payload.artefacts, setSwitchView)
  };

  return (
    <Table
      id="scheduleTableId"
      tableData={tableData}
      emptyStateText="No entries found"
      className={className}
    />
  );
};
